import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SvgIconModule } from 'shared/components/svg-icon/svg-icon.module';
import { CompactAgentStatComponent } from './compact-agent-stat.component';

@NgModule({
  imports: [
    CommonModule,
    SvgIconModule,
    TranslateModule.forChild()
  ],
  declarations: [
    CompactAgentStatComponent
  ],
  exports: [
    CompactAgentStatComponent
  ]
})
export class CompactAgentStatModule {}
